import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = { class: "d-flex flex-column" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_4 = {
  key: 1,
  class: "d-flex"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, {
      justify: "space-between",
      align: "center",
      dense: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              align: "center",
              dense: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      color: "#F4F4F4",
                      variant: "flat",
                      class: "pa-2",
                      height: "48"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          dense: "",
                          align: "center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "6",
                              md: "8"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, {
                                  "no-gutters": "",
                                  align: "center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "5",
                                      md: "auto"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_dialog, {
                                          width: "500",
                                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.resetDialog()))
                                        }, {
                                          activator: _withCtx(({ props }) => [
                                            _createVNode(_component_v_btn, _mergeProps(props, {
                                              size: "small",
                                              variant: "plain",
                                              color: "primary"
                                            }), {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.mdAndUp ? 'Add quicksight user' : 'Add'), 1)
                                              ]),
                                              _: 2
                                            }, 1040)
                                          ]),
                                          default: _withCtx(({ isActive }) => [
                                            _createVNode(_component_v_card, { title: "Add quicksight user" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_card_text, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_form, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_row, null, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_col, { cols: "12" }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_combobox, {
                                                                  class: "app-combobox",
                                                                  clearable: "",
                                                                  "custom-filter": _ctx.filterUsers,
                                                                  items: _ctx.filteredUsers,
                                                                  "item-title": item => (typeof item === 'object' && item !== null) ? _ctx.fullName(item.first_name, item.last_name) : item,
                                                                  "item-value": "id",
                                                                  "hide-details": "",
                                                                  density: "comfortable",
                                                                  placeholder: "Search users",
                                                                  "return-object": "",
                                                                  "menu-props": { maxWidth: 452 },
                                                                  modelValue: _ctx.selectedUser,
                                                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedUser) = $event)),
                                                                  onBlur: _ctx.clearIfNoSelection
                                                                }, {
                                                                  selection: _withCtx(({ item }) => [
                                                                    _createElementVNode("div", _hoisted_1, [
                                                                      (typeof item.raw === 'object' && item.raw !== null)
                                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                            _createVNode(_component_v_list_item_title, null, {
                                                                              default: _withCtx(() => [
                                                                                _createTextVNode(_toDisplayString(_ctx.fullName(item.raw.first_name, item.raw.last_name)), 1)
                                                                              ]),
                                                                              _: 2
                                                                            }, 1024),
                                                                            _createVNode(_component_v_list_item_subtitle, null, {
                                                                              default: _withCtx(() => [
                                                                                _createTextVNode(_toDisplayString(item.raw.email), 1)
                                                                              ]),
                                                                              _: 2
                                                                            }, 1024)
                                                                          ], 64))
                                                                        : (_openBlock(), _createBlock(_component_v_list_item_title, { key: 1 }, {
                                                                            default: _withCtx(() => [
                                                                              _createTextVNode(_toDisplayString(item.raw), 1)
                                                                            ]),
                                                                            _: 2
                                                                          }, 1024))
                                                                    ])
                                                                  ]),
                                                                  item: _withCtx(({ props, item }) => [
                                                                    _createElementVNode("div", _hoisted_2, [
                                                                      _createVNode(_component_v_list_item, _mergeProps(props, {
                                                                        onClick: ($event: any) => (_ctx.selectedUser = item.raw)
                                                                      }), {
                                                                        default: _withCtx(() => [
                                                                          _createVNode(_component_v_list_item_subtitle, null, {
                                                                            default: _withCtx(() => [
                                                                              _createTextVNode(_toDisplayString(item.raw.email), 1)
                                                                            ]),
                                                                            _: 2
                                                                          }, 1024)
                                                                        ]),
                                                                        _: 2
                                                                      }, 1040, ["onClick"])
                                                                    ])
                                                                  ]),
                                                                  _: 1
                                                                }, 8, ["custom-filter", "items", "item-title", "modelValue", "onBlur"])
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_card_actions, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_spacer),
                                                    _createVNode(_component_v_btn, {
                                                      loading: _ctx.loading,
                                                      disabled: !_ctx.selectedUser?.id || _ctx.loading,
                                                      color: "primary",
                                                      onClick: ($event: any) => {_ctx.addQuicksightUser(); isActive.value = false}
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(" Add Quicksight user ")
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["loading", "disabled", "onClick"])
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "5",
                                      md: "auto"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn, {
                                          size: "small",
                                          variant: "plain",
                                          disabled: !_ctx.selectedUsers.length,
                                          color: "primary",
                                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.removeQuicksightUser()))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.mdAndUp ? 'Remove quicksight user' : 'Remove'), 1)
                                          ]),
                                          _: 1
                                        }, 8, ["disabled"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_data_table, {
      items: _ctx.quicksightUsers,
      headers: _ctx.headers,
      "show-select": "",
      "return-object": "",
      modelValue: _ctx.selectedUsers,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedUsers) = $event)),
      height: "calc(100vh - 260px)"
    }, {
      [`item.status`]: _withCtx(({ item }) => [
        (item.status === 'active')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_v_icon, {
                start: "",
                icon: "mdi-circle",
                color: "success"
              }),
              _createTextVNode(" Active ")
            ]))
          : _createCommentVNode("", true),
        (item.status === 'pending')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_v_icon, {
                start: "",
                icon: "mdi-circle",
                color: "grey"
              }),
              _createTextVNode(" Pending ")
            ]))
          : _createCommentVNode("", true)
      ]),
      [`item.full_name`]: _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(_ctx.fullName(item.first_name, item.last_name)), 1)
      ]),
      _: 2
    }, 1032, ["items", "headers", "modelValue"])
  ]))
}